import { createContext } from "react";
import { Project } from "../../../../js/parsegenerated";

export const ProjectContext = createContext<Project | undefined>(undefined);
export const ProjectContextProvider = ProjectContext.Provider;
